import React, { useState,useEffect } from 'react';
import { useRef } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';

function LaunchEval(arg) {
  const [show, setShow] = useState(arg.flag);
  const [question,setQstn] = useState('');
  const [ans,setAns] = useState('');

    useEffect(() => {
        try{
            const qstnObj = arg.data.answers;
            setQstn(Object.keys(arg.data.answers)[0]);
            setAns(qstnObj[Object.keys(arg.data.answers)[0]]);
        }catch(er){
            setShow(false);
        }
      
    
      
      
    }, [])
    
  const handleClose = () => {
    setShow(false);
    arg.handler();
  }
  const handleShow = () => setShow(true);

  const updateAsCompleted=()=>{
    setShow(false);
    const req = {
        assessmentId: arg.data.assessmentId,
        userId : arg.data.userId,
        status : "P"
      }
      arg.callback(req);
  }

  const updateAsFailed =()=>{
    setShow(false);
    const req = {
        assessmentId: arg.data.assessmentId,
        userId : arg.data.userId,
        status : "F"
      }
      arg.callback(req);
  }
 

  return (
    <>
      <Modal show={show} onHide={handleClose}  backdrop="static" keyboard={false} size="lg">
        <Modal.Header>
          <Modal.Title>Assessment Evaluation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
            
               <Form>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Assessment</Form.Label>
                  <Form.Control value={arg.data.assessmentName} type="text" disabled/>
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Question</Form.Label>
                  <Form.Control value={question} type="text" disabled/>
                </Form.Group>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>Answer</Form.Label>
                  <Form.Control as="textarea" rows={3} value={ans} disabled />
                </Form.Group>
                
              </Form>
            
           
          
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            CLOSE
          </Button>
         <Button variant="success" onClick={updateAsCompleted}>
            MARK AS COMPLETED
          </Button>
          <Button variant="danger" onClick={updateAsFailed}>
            MARK AS FAILED
          </Button>
            
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LaunchEval;

